import { Link } from "react-router";
import { CONTO_ALBUM_ID as ALBUM_CONTO_ID } from "@historia/shared/contracts";
import type { AlbumWithCount as AlbumComContagem } from "@historia/shared/types";

/**
 * Fila de "capas" das pastas, mostrada no topo do álbum.
 * `ativo` = id do álbum atualmente filtrado (ou null = todas as fotos).
 * O álbum especial "Conto" aparece fixo logo a seguir a "Todas as fotos".
 */
export function CapasAlbuns({
  albuns,
  ativo,
  contagemConto,
}: {
  albuns: AlbumComContagem[];
  ativo: string | null;
  contagemConto: number;
}) {
  return (
    <div className="mb-8">
      {/* Carrossel horizontal: numa só linha, desliza de lado (sobretudo no
          telemóvel). As margens negativas deixam a fila "sangrar" até às bordas,
          dando o indício de que há mais ao lado. A grelha de fotos não muda. */}
      <div className="scroll-x-suave -mx-6 flex flex-nowrap items-center gap-2 overflow-x-auto px-6">
        {/* Todas as fotos */}
        <Link
          to="/album"
          aria-current={ativo === null ? "page" : undefined}
          className={`shrink-0 whitespace-nowrap rounded-2xl border px-4 py-2 text-sm font-semibold transition-colors ${
            ativo === null
              ? "border-ouro bg-ouro/15 text-ouro-600"
              : "border-ouro/25 text-tinta-700 hover:bg-creme-200/60"
          }`}
        >
          Todas as fotos
        </Link>

        {/* Álbum especial "Conto" — fixo, só-leitura (alimentado pela página Conto) */}
        <Link
          to={`/album?album=${ALBUM_CONTO_ID}`}
          aria-current={ativo === ALBUM_CONTO_ID ? "page" : undefined}
          className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-2xl border px-4 py-2 text-sm font-semibold transition-colors ${
            ativo === ALBUM_CONTO_ID
              ? "border-ouro bg-ouro/15 text-ouro-600"
              : "border-ouro/25 text-tinta-700 hover:bg-creme-200/60"
          }`}
        >
          <span aria-hidden>📖</span>
          <span>Conto</span>
          <span className="rounded-full bg-creme-200/80 px-2 text-xs text-tinta-700/80">
            {contagemConto}
          </span>
        </Link>

        {albuns.map((album) => (
          <Link
            key={album.id}
            to={`/album?album=${album.id}`}
            aria-current={ativo === album.id ? "page" : undefined}
            className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-2xl border px-4 py-2 text-sm font-semibold transition-colors ${
              ativo === album.id
                ? "border-ouro bg-ouro/15 text-ouro-600"
                : "border-ouro/25 text-tinta-700 hover:bg-creme-200/60"
            }`}
          >
            <span aria-hidden>{album.icone}</span>
            <span>{album.nome}</span>
            <span className="rounded-full bg-creme-200/80 px-2 text-xs text-tinta-700/80">
              {album.total}
            </span>
          </Link>
        ))}

          <Link
            to="/album/pastas"
            className="shrink-0 whitespace-nowrap rounded-2xl border border-dashed border-ouro/40 px-4 py-2 text-sm font-semibold text-ouro-600 transition-colors hover:bg-creme-200/60"
          >
            + Gerir álbuns
          </Link>
      </div>
    </div>
  );
}
